export { default } from './CategoryList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Category/CategoryList/index.js